<template>
  <v-list-item >
    <v-list-item-content :class="{ 'warning--text': sortBy === sort }">
        <v-list-item-subtitle>{{label }}</v-list-item-subtitle>
        <v-list-item-title :class="'subtitle-'+((size=='large')?'1':'2')"> {{  value}}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
    props:['label','value','sortBy','size','sort']
};
</script>

<style>
</style>